import styled, { css } from "styled-components";
import { Box, Button } from "@mui/material";
import { lightBlue2 } from "styles/theme";
import { lightPrimary } from "styles/theme";
import { Header as HeaderDataGrid } from 'components/DataGrid/Style'
import { styled as muiStyled } from '@mui/material/styles';
import { Scroll, ScrollCss } from "styles/GlobalCss";
import { bg } from "styles/theme";
import { thirdly4 } from "styles/theme";
import { thirdly2 } from "styles/theme";

export const headercss = css`
grid-template-columns:  120px 120px 120px 100px auto 130px 130px;
`

export const WrapBasicButton = styled(Button)`
box-shadow: none !important;
border:1px solid ${lightPrimary} !important;
`

export const WrapFullButton = styled(Button)`
box-shadow: none !important;
border:1px solid ${lightBlue2} !important;
`

export const IndicationLabel = styled.div`
color:${props => props.color};
`

export const WrapIndication = styled.div`
width: ${props => props.size === "sm" ? `25px` : `35px`};
.MuiSvgIcon{
    color:pink !important
}
`

export const TableToolbarStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    flexGrow: 1,
    justifyContent: "end",
    alignItems: "center",
    columnGap: "22px",
    marginRight: 40,
    '.default-view': {
        color: "#26445A80",
        textDecoration: "underline"
    },
    '.view-types': {
        border: `1px solid ${bg}`,
        background: thirdly4,
        padding: 6,
        display: "flex",
        columnGap: 10,
        borderRadius: 10
    }
}));


export const WrapViewTypes = muiStyled(Box)(({ theme, $systemUI }) => ({
    marginLeft: 10
}));

export const DoughnutChartsStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: "100%",
    overflow: "auto",
    '.chart-cards': {
        display: "flex",
        columnGap: 40,
        flexWrap: "wrap",
        rowGap: 20,
        height: "100%",
        overflow: "auto",
        ...ScrollCss
    },
    '.chart-card-styles': {
        border: `1px solid ${thirdly2}`,
        borderRadius: 15,
        width: 300,
        background: "white",
        height: 600,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        rowGap: 20,
    },

    '.chart-list-square': {
        width: 15,
        height: 15,
    },
    '.chart-list': {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.chart-list-item': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    },
    '.card-content': {
        display: "flex",
        flexDirection: "column",
        rowGap: 40,
        alignItems: "center"
    },
    '.doughnut-chart': {
        height: 250,
        width: 250
    },
    '.card-header': {
        display: "flex",
    },
    '.card-label': {
        background: thirdly4,
        border: `1px solid ${thirdly2}`,
        borderRadius: 5,
        padding: "6px 12px"
    }
}));

export const RateAndAccuracyHeaderStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    // alignItems: "center",
    columnGap: "10px",
    '.tooltip': {
        position: "relative",
        bottom: 10,
        right: 10,
        width: 3
    },
    '.cell-with-icon': {
        textWrap: "nowrap",
        lineHeight: 1.2,
        [theme.breakpoints.down('md')]: {
            width: "auto"
        }
    }
}));

export const AssessmentCategoryCellStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    columnGap: 10,
    alignItems: "center",
    ".MuiSvgIcon-root": {
        fill: "transparent !important"
    }
}));


export const ProsodyCellStyles = muiStyled(Box)(({ color }) => ({
    color: color
}));

export const Header = styled(HeaderDataGrid)`
width:100%;
display: flex;
overflow-y:hidden;
overflow-x:auto;
row-gap: 10px;
justify-content: flex-start;
padding:15px 0px;
${props => props.headercss && props.headercss};
${Scroll};
`

export const WrapFiltersHeader = styled.div`
display:flex;
align-items:center;
height:${props => props.height ? `${props.height}px` : "70px"};
`
